import { ResponseArray } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import queryString from 'query-string'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import { CreateKPIEmployeePayload } from '../types'

export const getKPIEmployees = async (payload: DataGridPayload) => {
    const response = await datacentral.get<ResponseArray<any>>(
        `/kpis?${queryString.stringify(payload)}`
    )
    return response?.data
}

export const getKPIProductGroups = async () => {
    const response =
        await datacentral.get<ResponseArray<string>>(`/kpis/product_groups`)
    return response?.data
}

export const createKPIEmployee = async (payload: CreateKPIEmployeePayload) => {
    const response = await datacentral.post<ResponseArray<any>>(
        `/kpis`,
        payload
    )
    return response?.data
}

export const deleteKPIEmployee = async (id: number) => {
    const response = await datacentral.delete<ResponseArray<any>>(`/kpis/${id}`)
    return response?.data
}
